import {Component, forwardRef, Injector} from "@angular/core";
import {ColumnComponent} from "../../../grid/column.component";
import {AbstractMultiSelectColumnComponent} from "./abstract-multi-select-column.component";

/**
 * Provides a multiple selection edit column. <wbo-select-options> is used to provide the options.
 */
@Component({
    selector: "wbo-multi-select-column",
    styleUrls: ["./multi-select-column.component.scss"],
    templateUrl: "./multi-select-column.component.html",
    providers: [
        {provide: ColumnComponent, useExisting: forwardRef(() => MultiSelectColumnComponent), multi: true}
    ]
})
export class MultiSelectColumnComponent extends AbstractMultiSelectColumnComponent {
    constructor(injector: Injector) {
        super(injector);
    }
}
